<template>
  <div class="container">
    <div class="heading-container">
      <h4>Search result for:</h4>
      <strong>&nbsp;{{searchTerm}}</strong>
    </div>
    <loading-spinner v-if="isLoading"></loading-spinner>
    <tile-container v-if="apps && apps.length > 0" :apps="apps" :view="view"></tile-container>
    <div v-if="!isLoading && (!apps || apps.length == 0)" class="no-results-container">
      <p>Sorry, we could not find anything for this search term.</p>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import api from "@/api";
import * as CONSTANTS from "../constants.js";
import TileContainer from "@/components/TileContainer";
import LoadingSpinner from "@/components/LoadingSpinner";
import util from "@/util";
import axios from 'axios'

export default {
  name: "SearchResults",
  components: {
    TileContainer,
    LoadingSpinner
  },
  data: function() {
    return {
      CONSTANTS,
      apps: [],
      isLoading: false,
      searchIndex: 0,
      view: { id: CONSTANTS.VIEW_IDS.SEARCH_VIEW_ID }
    };
  },
  watch: {
    searchTerm() {
      this.getSearchResults();
    }
  },
  computed: {
    ...mapGetters(["getApplicationById"]),
    searchTerm() {
      return this.$route.query.q;
    }
  },
  mounted() {
    this.getSearchResults();
  },
  methods: {
    ...mapActions(["addAlert", "handleResponseAlerts"]),
    getSearchResults() {
      this.searchIndex++
      this.apps = [];
      this.isLoading = true;
      if (!this.searchTerm) {
        this.isLoading = false;
        return;
      }
      let st = this.searchTerm.replace(/[^\w\s]/gi, "")
      
      api.getSearchResults(st)
      .then(response => {
        this.handleResponseAlerts(response);
        var appIds = response.data.data;
        if (this.searchIndex > 1) {
          this.searchIndex--
        } else {
          this.apps = [];
          appIds.forEach(appId => {
            var app = this.getApplicationById(appId.id)
            if (app) {
              this.apps.push(app)
            }
          });
          this.isLoading = false
          this.searchIndex = 0
        }
      }).catch(e => {
        console.error(e);
        this.isLoading = false;
        this.addAlert(
          util.createAlert(
            null,
            CONSTANTS.ERROR_MSGS.GENERIC_ERROR,
            CONSTANTS.ALERT_CONTEXT.DANGER
          )
        );
      });
    }
  }
};
</script>
<style>
</style>
